
      <div class="form-with-lbl two-element">
        <div class="radio-container">
          <div class="form-control normal-radio-icon" >
            <label class="normal-radio-container {{error.errorCss}}">
              <input type="radio" name="radio-demo" [(ngModel)]="flag" [value]="1" id="radio-female" title="Mujer" (click)="submitAnswer('Female')">
              <div class="radiomark-container shadow-5 ">
                <div class="oval">
                  <img src="{{baseMakeImageUrl}}woman.svg">
                </div>
                <p class="item">Mujer</p>
              </div>
            </label>
          </div>

          <div class="form-control normal-radio-icon" >
            <label class="normal-radio-container {{error.errorCss}}" >
              <input type="radio" name="radio-demo" [(ngModel)]="flag" [value]="0" id="radio-male" title="Hombre" (click)="submitAnswer('Male')">
              <div class="radiomark-container shadow-5">
                <div class="oval">
                  <img src="{{baseMakeImageUrl}}man.svg">
                </div>
                <p class="item">Hombre</p>
              </div>
            </label>
          </div>
        </div>
        <p class="error" id="error-gender" *ngIf="error.isInValid">Para continuar, selecciona una opción</p>

      </div>

